import { isValidPhoneNumber } from "react-phone-number-input";
import { validateEmail } from "../utils/globalUtils";

const defaultOptions = [
  {
    checked: false,
    id: "signature",
    label: "Signature",
    value: "",
    width: 200,
    height: 60,
  },
  {
    checked: false,
    id: "name",
    label: "Signature Name",
    value: "",
    width: 200,
    height: 60,
  },
  {
    checked: false,
    id: "date",
    label: "Signature Date",
    value: "",
    width: 200,
    height: 60,
  },
  {
    checked: false,
    id: "initials",
    label: "Signature Initials",
    value: "",
    width: 200,
    height: 60,
  },
  {
    checked: false,
    id: "signtext",
    label: "Signature Text",
    value: "",
    width: 200,
    height: 60,
  },
  {
    checked: false,
    id: "signcheckbox",
    label: "Signature Checkbox",
    value: "",
    width: 50,
    height: 50,
  },
];

class SignerConfig {
  constructor(
    image_url = "",
    options = defaultOptions,
    point = {},
    signature_type = "FULLNAME",
  ) {
    this.image_url = image_url;
    this.options = options;
    this.point = point;
    this.signature_type = signature_type;
  }

  set image_url(image_url) {
    this._image_url = image_url;
  }

  set point(point) {
    this._point = point;
  }

  set signature_type(signature_type) {
    this._signature_type = signature_type;
  }

  get image_url() {
    return this._image_url;
  }

  get point() {
    return this._point;
  }

  get signature_type() {
    return this._signature_type;
  }

  updateOptions(id, checked, componentID) {
    this.tag_id = componentID;
    this.tag_type = id;
    this.options = this.options.map(op => {
      if (id === op.id) {
        return { ...op, checked };
      }
      return op;
    });
    return this;
  }

  filterOptions() {
    this.options = this.options.filter(op => op.checked);
    return this;
  }

  get signer_config() {
    return {
      image_url: this.image_url,
      options: this.options,
      point: this.point,
      signature_type: this.signature_type,
      tag_type: this.tag_type,
      tag_value: "",
      is_required: false,
      tag_label: "",
      tag_id: this.tag_id,
    };
  }
}

class PDFSignerConfig extends SignerConfig {
  constructor(
    image_url,
    options,
    point,
    signature_type,
    name_point,
    date_point,
    initials_point,
  ) {
    super(image_url, options, point, signature_type);
    this.name_point = name_point;
    this.date_point = date_point;
    this.initials_point = initials_point;
  }

  set name_point(name_point) {
    this._name_point = name_point;
  }

  set date_point(date_point) {
    this._date_point = date_point;
  }

  set initials_point(initials_point) {
    this.initials_point = initials_point;
  }

  get name_point() {
    return this._name_point;
  }

  get date_point() {
    return this._date_point;
  }

  get initials_point() {
    return this.initials_point;
  }
}
class SignerTag {
  constructor(
    id,
    component_id,
    signer_identity_id,
    tag_type = "",
    signer_config,
  ) {
    this.id = id;
    this.component_id = component_id;
    this.signer_identity_id = signer_identity_id;
    this.tag_type = tag_type;
    const { image_url, options, point, signature_type } = signer_config;
    this.signer_config = new SignerConfig(
      image_url,
      options,
      point,
      signature_type,
    );
  }

  set id(id) {
    this._id = id;
  }

  set component_id(component_id) {
    this._component_id = component_id;
  }

  set signer_identity_id(signer_identity_id) {
    this._signer_identity_id = signer_identity_id;
  }

  set tag_type(tag_type) {
    this._tag_type = tag_type;
  }

  set signer_config(signer_config) {
    this._signer_config = signer_config;
  }

  get id() {
    return this._id;
  }

  get component_id() {
    return this._component_id;
  }

  get signer_identity_id() {
    return this._signer_identity_id;
  }

  get tag_type() {
    return this.tag_type;
  }

  get signer_config() {
    return this._signer_config;
  }
}

class Signatory {
  constructor(
    signer_identity_id,
    signer_email,
    first_name,
    last_name,
    tags = [],
  ) {
    this.signer_identity_id = signer_identity_id;
    this.signer_email = signer_email;
    this.first_name = first_name;
    this.last_name = last_name;
    this.tags = tags;
  }

  set signer_email(signer_email) {
    this._signer_email = signer_email;
  }

  set signer_identity_id(signer_identity_id) {
    this._signer_identity_id = signer_identity_id;
  }

  set first_name(first_name) {
    this._first_name = first_name;
  }

  set last_name(last_name) {
    this._last_name = last_name;
  }

  set tags(t) {
    this._tags =
      (t &&
        t.map(
          ({ id, component_id, tag_type, signer_config }) =>
            new SignerTag(
              id,
              component_id,
              this.signer_identity_id,
              tag_type,
              signer_config,
            ),
        )) ||
      [];
  }

  get signer_email() {
    return this._signer_email;
  }

  get signer_identity_id() {
    return this._signer_identity_id;
  }

  get first_name() {
    return this._first_name;
  }

  get last_name() {
    return this._last_name;
  }

  get tags() {
    return this._tags;
  }

  get signer() {
    return {
      signer_identity_id: this.signer_identity_id,
      first_name: this.first_name,
      last_name: this.last_name,
      signer_email: this.signer_email,
      tags: this.tags,
    };
  }
}

class Signer {
  constructor(
    user_email,
    first_name,
    last_name,
    recipientId,
    mobile_number,
    auth_type,
    esign_via_sms = false,
  ) {
    this.user_email = user_email;
    this.first_name = first_name;
    this.last_name = last_name;
    this.recipientId = recipientId;
    this.auth_type = auth_type;
    this.esign_via_sms = esign_via_sms;
    this.mobile_number = mobile_number;
  }

  set user_email(user_email) {
    if (validateEmail(user_email)) {
      this._user_email = user_email;
    } else {
      throw new Error(`Invalid email - ${user_email}`);
    }
  }

  set first_name(first_name) {
    if (first_name && first_name.trim()) {
      this._first_name = first_name;
    } else {
      throw new Error(`Invalid first name - ${first_name}`);
    }
  }

  set last_name(last_name) {
    if (last_name && last_name.trim()) {
      this._last_name = last_name;
    } else {
      throw new Error(`Invalid last name - ${last_name}`);
    }
  }

  set recipientId(recipientId) {
    this._recipientId = recipientId;
  }

  set mobile_number(mobile_number) {
    if (this.esign_via_sms) {
      if (isValidPhoneNumber(mobile_number)) {
        this._mobile_number = mobile_number;
      } else {
        throw new Error(`Invalid mobile number - ${mobile_number}`);
      }
    } else {
      this._mobile_number = mobile_number;
    }
  }

  set esign_via_sms(esign_via_sms) {
    this._esign_via_sms = esign_via_sms;
  }

  get user_email() {
    return this._user_email;
  }

  get first_name() {
    return this._first_name;
  }

  get last_name() {
    return this._last_name;
  }

  get recipientId() {
    return this._recipientId;
  }

  get mobile_number() {
    return this._mobile_number;
  }

  get esign_via_sms() {
    return this._esign_via_sms;
  }

  get signer() {
    return {
      user_email: this.user_email,
      first_name: this.first_name,
      last_name: this.last_name,
      // recipientId: this.recipientId,
      mobile_number: this.mobile_number,
      esign_via_sms: this.esign_via_sms,
      auth_type: this.auth_type,
    };
  }
}

class SubmitSignatory extends Signer {
  constructor(...args) {
    super(args);
  }

  set user_email(user_email) {
    this._user_email = user_email;
  }

  set first_name(first_name) {
    this._first_name = first_name;
  }

  set last_name(last_name) {
    this._last_name = last_name;
  }

  set recipientId(recipientId) {
    this._recipientId = recipientId;
  }

  set mobile_number(mobile_number) {
    this._mobile_number = mobile_number;
  }

  set esign_via_sms(esign_via_sms) {
    this._esign_via_sms = esign_via_sms;
  }

  get user_email() {
    return this._user_email;
  }

  get first_name() {
    return this._first_name;
  }

  get last_name() {
    return this._last_name;
  }

  get recipientId() {
    return this._recipientId;
  }

  get mobile_number() {
    return this._mobile_number;
  }

  get esign_via_sms() {
    return this._esign_via_sms;
  }

  get signer() {
    return {
      user_email: this.user_email,
      first_name: this.first_name,
      last_name: this.last_name,
      // recipientId: this.recipientId,
      mobile_number: this.mobile_number,
      esign_via_sms: this.esign_via_sms,
      auth_type: this.auth_type,
    };
  }
}
export {
  Signer,
  Signatory,
  SignerTag,
  SignerConfig,
  PDFSignerConfig,
  SubmitSignatory,
};
